import { isNumber } from 'lodash-es'
import { useCallback, useMemo } from 'react'

import { TCoordinates, useBridge } from '@/shared/lib'

export const MAP_EVENT_TYPE = {
  DRAG_START: 'map.dragStart',
  DRAG_END: 'map.dragEnd',
  GEOLOCATION_PERMISSION: 'map.location.userLocation', // response : map.location.setUserLocation
}

export const useMapBridge = () => {
  const { bridge } = useBridge()

  const notifyDragStart = useCallback(() => {
    if (!bridge) return

    bridge.postMessage({
      type: MAP_EVENT_TYPE.DRAG_START,
    })
  }, [bridge])

  const notifyDragEnd = useCallback(() => {
    if (!bridge) return

    bridge.postMessage({
      type: MAP_EVENT_TYPE.DRAG_END,
    })
  }, [bridge])

  const getUserLocation =
    useCallback(async (): Promise<TCoordinates | null> => {
      if (!bridge) return null

      const position = await bridge.postMessageAsync<Partial<TCoordinates>>(
        {
          type: MAP_EVENT_TYPE.GEOLOCATION_PERMISSION,
        },
        null,
      )

      if (isNumber(position.lat) && isNumber(position.lng)) {
        return position as TCoordinates
      }

      return null
    }, [bridge])

  const mapBridge = useMemo(
    () => ({
      notifyDragStart,
      notifyDragEnd,
      getUserLocation,
    }),
    [notifyDragStart, notifyDragEnd, getUserLocation],
  )

  return {
    bridge,
    mapBridge,
  }
}
